import { render, staticRenderFns } from "./myProfile.vue?vue&type=template&id=2ec28776"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"
import style0 from "./myProfile.vue?vue&type=style&index=0&id=2ec28776&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports